// apps/web/src/features/projects/wizard/teamSections.ts
import type { Role, TeamRoleKey } from '@altyor-kronos/shared-types';

export interface TeamSection {
  key: TeamRoleKey;
  labelKey: string;
  filterRole: Role | null;
  required: boolean;
}

export const TEAM_SECTIONS: TeamSection[] = [
  { key: 'managers', labelKey: 'projects.wizard.team.managers', filterRole: null, required: true },
  { key: 'rdLead', labelKey: 'projects.wizard.team.rdLead', filterRole: 'rd_manager', required: false },
  { key: 'rdMeca', labelKey: 'projects.wizard.team.rdMeca', filterRole: 'rd_meca', required: false },
  { key: 'rdElec', labelKey: 'projects.wizard.team.rdElec', filterRole: 'rd_elec', required: false },
  { key: 'testBench', labelKey: 'projects.wizard.team.testBench', filterRole: 'rd_test_bench', required: false },
  { key: 'dft', labelKey: 'projects.wizard.team.dft', filterRole: 'dft', required: false },
  { key: 'supplyChain', labelKey: 'projects.wizard.team.supplyChain', filterRole: 'supply_chain', required: false },
  { key: 'quality', labelKey: 'projects.wizard.team.quality', filterRole: 'quality', required: false },
  { key: 'bizdev', labelKey: 'projects.wizard.team.bizdev', filterRole: 'bizdev', required: false },
  { key: 'marketing', labelKey: 'projects.wizard.team.marketing', filterRole: 'marketing', required: false },
  // Rempli automatiquement par onTimeEntryCreated ; un manager peut en sortir quelqu'un (#66).
  { key: 'contributors', labelKey: 'projects.wizard.team.contributors', filterRole: null, required: false },
];
